var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDisabled
    ? _c(
        "div",
        { staticClass: "system-in-maintainance m-5 text-center" },
        [
          _c("omegaup-markdown", {
            attrs: { markdown: _vm.T.coderOfTheMonthSystemInMaintainance }
          }),
          _c("font-awesome-icon", { attrs: { icon: ["fas", "cogs"] } })
        ],
        1
      )
    : _c(
        "table",
        { staticClass: "table table-striped table-hover table-responsive-sm" },
        [
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "text-center", attrs: { scope: "col" } }),
              _c(
                "th",
                { staticClass: "text-center", attrs: { scope: "col" } },
                [_vm._v(" " + _vm._s(_vm.T.codersOfTheMonthUser) + " ")]
              ),
              _c(
                "th",
                { staticClass: "text-center", attrs: { scope: "col" } },
                [_vm._v(" " + _vm._s(_vm.T.codersOfTheMonthCountry) + " ")]
              )
            ])
          ]),
          _c(
            "tbody",
            _vm._l(_vm.coders, function(coder, index) {
              return _c("tr", { key: index }, [
                _c("td", { staticClass: "text-center" }, [
                  _c("img", { attrs: { src: coder.gravatar_32 } })
                ]),
                _c(
                  "td",
                  { staticClass: "text-center align-middle" },
                  [
                    _c("omegaup-user-username", {
                      attrs: {
                        classname: coder.classname,
                        linkify: true,
                        username: coder.username
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "td",
                  { staticClass: "text-center align-middle" },
                  [
                    _c("omegaup-countryflag", {
                      attrs: { country: coder.country_id }
                    })
                  ],
                  1
                )
              ])
            }),
            0
          )
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }